import { createBrowserHistory, History } from 'history' 

const history = createBrowserHistory();

export default history;
